import {NzModalService} from "ng-zorro-antd/modal";
import {InputBoxData} from "src/models/input-box-data";
import {InputBoxModalComponent} from "../components/input-box.component";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class InputBoxService {
    constructor(private modalService: NzModalService) {}

    open(data?: InputBoxData): Promise<string | null> {
        return new Promise(resolve => {
            const modalRef = this.modalService.create({
                nzTitle: data?.title || "Save Item",
                nzContent: InputBoxModalComponent,
                nzWidth: 400,
                nzData: data,
                nzFooter: [
                    {
                        label: data?.cancelText || "Cancel",
                        onClick: () => {
                            modalRef.destroy();
                            resolve(null);
                        }
                    },
                    {
                        label: data?.okText || "Save",
                        type: "primary",
                        onClick: () => {
                            const instance = modalRef.componentInstance;
                            if (instance && instance.name.trim()) {
                                resolve(instance.name.trim());
                                modalRef.close();
                            }
                        }
                    }
                ]
            });
            modalRef.afterClose.subscribe(val => resolve(val));
        });
    }
}
